import React, { useEffect, useState } from 'react';
import { IUrlParameter } from './types';
import { FilterPanel } from './FilterPanel';
import { useParams } from 'react-router-dom';
import { RootState } from 'app/main/rootReducer';
import { useDispatch, useSelector } from 'react-redux';
import { BookingDetailsPage } from './BookingDetailsPage';
import { ReportingDetailsPage } from './ReportingDetailsPage';
import { saveSelectedVenue } from 'app/reducers/dashboardSlice';
import { AmountSpentDetailsPage } from './AmountSpentDetailsPage';
import { DashboardPage, getRandomColorForGraph, SelectReportByUrlParameter } from './helper';
import { BookingsCountByServiceWrapper } from './BookingsCountByServiceWrapper';
import { Backdrop, CircularProgress, makeStyles, Paper, Typography } from '@material-ui/core';
import { IVenue } from 'app/reducers/venueSlice';

const NS = 'ReportingDashboard';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

/**
 * Renders the dashboard which consists of reports, lists and graphs.
 */
export const ReportingDashboard = () => {

  const dispatch = useDispatch();
  const classes = useStyles();
  const { page } = useParams<IUrlParameter>();
  const [open, setOpen] = useState<boolean>(false);
  const { selectedVenue } = useSelector((state: RootState) => state.venueReducer);
  const { selectedReport, selectedVenues } = useSelector((state: RootState) => state.dashboardReducer.filterParameters);

  // Set default venue
  useEffect(() => { dispatch(saveSelectedVenue(selectedVenue)) }, [selectedVenue]);

  // Select the report using the url parameter
  useEffect(() => { SelectReportByUrlParameter(page) }, [page]);

  /**
   * Initially, reporting dashboard is rendered on page load.
   * Renders specific report, as per the selected option from the reports dropdown.
   */
  const renderReport = () => {
    switch (selectedReport.id) {
      case DashboardPage.BOOKING_DETAILS:
        return <BookingDetailsPage onHandleLoadSpinner={handleToggle} />
      case DashboardPage.AMOUNT_SPENT_DETAILS:
        return <AmountSpentDetailsPage />
      case DashboardPage.SERVICES:
        let sortedSelectedVenues = [...selectedVenues];
        let servicesItems = sortedSelectedVenues
          .sort((a: IVenue, b:IVenue) => {
            return (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0;
          })
          .map(v => {
            const randomColor = getRandomColorForGraph(selectedVenues.length > 1);
            return <BookingsCountByServiceWrapper key={v.id} venueId={v.id} venueName={v.name} randomGraphColor = {randomColor}/> 
          });
        return (
          <Paper id={`paper_bookingsCountByServiceWrapper`}>
            <Typography variant="h5" gutterBottom component="div">Bookings By Service Types</Typography>
            {servicesItems}
          </Paper>);
      default:
        return <ReportingDetailsPage />
    }
  }

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = (value: boolean) => {
    setOpen(value);
  };

  return (
    <>
      <FilterPanel onHandleLoadSpinner={handleToggle} />
      <Backdrop
        className={classes.backdrop}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      {renderReport()}
    </>
  )
}